import { WidgetInstance } from 'friendly-challenge'

import store from 'shared/store'

/**
 * Widget callback function for login button toggling.
 */
const loginWidgetCallback = () => {
  document.getElementById('login-submit-btn')?.removeAttribute('disabled')
}

const registrationWidgetCallback = () => {
  document.getElementById('register-submit-btn')?.removeAttribute('disabled')
}

const productConsultationMessageFormWidgetCallback = () => {
  document
    .getElementById('callback-form-message-submit-btn')
    ?.removeAttribute('disabled')
}

const productConsultationCallbackFormWidgetCallback = () => {
  document
    .getElementById('callback-form-callback-submit-btn')
    ?.removeAttribute('disabled')
}

const forgotPasswordFormWidgetCallback = () => {
  document
    .getElementById('forgotpassword-form-button')
    ?.removeAttribute('disabled')
}

const tenantWithEuAPI = ['at-qs', 'at']

const createFCWidget = (
  startMode: 'auto' | 'focus' | 'none' = 'focus',
  selector: string,
  doneCallBack: () => void,
  errorCallBack: () => void
) => {
  const container = document.querySelector<HTMLElement>(selector)

  const {
    publicConfig: { tenant },
  } = store.getPublicRuntimeConfig()
  let puzzleUrl = 'https://api.friendlycaptcha.com/api/v1/puzzle'
  if (tenantWithEuAPI.includes(tenant)) {
    puzzleUrl = 'https://eu-api.friendlycaptcha.eu/api/v1/puzzle'
  }

  if (!container) {
    return
  }

  new WidgetInstance(container, {
    startMode,
    puzzleEndpoint: puzzleUrl,
    doneCallback: doneCallBack,
    errorCallback: errorCallBack,
  })
}

const createFCWidgetForLogin = () => {
  createFCWidget(
    'auto',
    '#loginForm-frc-captcha',
    loginWidgetCallback,
    loginWidgetCallback
  )
}

const createFCWidgetForRegistration = () => {
  createFCWidget(
    'auto',
    '#registerForm-frc-captcha',
    registrationWidgetCallback,
    registrationWidgetCallback
  )
}

const createFCWidgetForProductConsultationMessageForm = () => {
  createFCWidget(
    'auto',
    '#productConsultationMessageForm-frc-captcha',
    productConsultationMessageFormWidgetCallback,
    productConsultationMessageFormWidgetCallback
  )
}

const createFCWidgetForProductConsultationCallbackForm = () => {
  createFCWidget(
    'auto',
    '#productConsultationCallbackForm-frc-captcha',
    productConsultationCallbackFormWidgetCallback,
    productConsultationCallbackFormWidgetCallback
  )
}

const createFCWidgetForForgotPasswordForm = () => {
  createFCWidget(
    'auto',
    '#forgotPasswordForm-frc-captcha',
    forgotPasswordFormWidgetCallback,
    forgotPasswordFormWidgetCallback
  )
}

export {
  createFCWidgetForLogin,
  createFCWidgetForRegistration,
  createFCWidgetForProductConsultationMessageForm,
  createFCWidgetForProductConsultationCallbackForm,
  createFCWidgetForForgotPasswordForm,
}
